module.exports = __webpack_public_path__ + "img/rg.4fb09578.webp";